import { isClosedOrder, findMainOrder } from '../domain/OrderBusinessRules';

/**
 * Determines if the main order is closed.
 *
 * @param {Object} orderRepository - The repository to fetch orders from.
 * @param {Object} params - The parameters for fetching orders.
 * @param {string} params.superOrderIdDms - The ID of the super order in DMS.
 * @param {string} params.email - The email associated with the order.
 * @param {string} params.dealerId - The ID of the dealer.
 *
 * @returns {Promise<boolean>} A promise that resolves to true if the main order is closed,
 * otherwise false.
 * @throws {Error} If no orders are found.
 */
export default async function isMainOrderClosed(orderRepository, {
  superOrderIdDms,
  email,
  dealerId,
}) {
  const orders = await orderRepository.getOrders({
    superOrderIdDms,
    email,
    dealerId,
  });

  if (orders.length === 0) {
    throw new Error('No orders found.');
  }

  return isClosedOrder(findMainOrder(orders));
}
